import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(updateLocale);
dayjs.extend(advancedFormat);
dayjs.extend(timezone);
dayjs.updateLocale('en', {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        m: '1 minute',
        mm: '%d minutes',
        h: '1 hour',
        hh: '%d hours',
        d: '1 day',
        dd: '%d days',
        M: '1 month',
        MM: '%d months',
        y: '1 year',
        yy: '%d years',
    },
});
export var dateNow = function () { return dayjs(); };
export var parseDate = function (isoDate) { return dayjs.utc(isoDate); };
export var parseDateLocal = function (isoDate) { return dayjs.utc(isoDate).local(); };
export var getDate = function (isoDate) { return parseDate(isoDate).format('MMMM D, YYYY'); };
export var getDateLocal = function (isoDate) { return parseDateLocal(isoDate).format('MMMM D, YYYY h:mmA z'); };
export var getDateLocalCustomFormat = function (isoDate, format) {
    return parseDateLocal(isoDate).format(format);
};
export var getDateNoDay = function (isoDate) { return parseDate(isoDate).format('MMMM YYYY'); };
export var getDateNoYear = function (isoDate) { return parseDate(isoDate).format('MMMM D'); };
export var getTimeOfDay = function (isoDate) { return parseDate(isoDate).format('hh:mm A'); };
export var getTimeFrom = function (isoDate, hour) {
    var date = parseDate(isoDate);
    if (hour) {
        date = date.hour(hour);
    }
    return date.fromNow(true);
};
export var getDayDiffFrom = function (isoDate) { return parseDate(isoDate).diff(dayjs(), 'day'); };
export var getTimeAgo = function (isoDate) { return parseDate(isoDate).format('MMM D, YYYY'); };
export var formatDate = function (isoDate) { return dayjs(isoDate).format('MMMM Do, hA'); };
// Renders an estimate for delivery, like "early June"
export var renderShippingDateEstimate = function (shippingDateEstimate) {
    if (!shippingDateEstimate)
        return '';
    var day = new Date(shippingDateEstimate).getDate();
    var estimateCopy;
    if (day >= 20) {
        estimateCopy = 'late';
    }
    else if (day <= 10) {
        estimateCopy = 'early';
    }
    else {
        estimateCopy = 'mid';
    }
    return estimateCopy + " " + getDateLocalCustomFormat(shippingDateEstimate, 'MMMM YYYY');
};
//# sourceMappingURL=time-converter.js.map